import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../../../components/Inputs/Select";

const options = [
	["any", "any"],
	["none", "none"],
	["cameEarly", "came-early"],
	["cameLate", "came-late"],
	["leftEarly", "left-early"],
	["leftLate", "left-late"],
	["notClocked", "not-clocked"],
	["notScheduled", "not-scheduled"],
	["longBreak", "long-break"],
	["shortBreak", "short-break"],
];

export const useClockExceptionsFilter = () => {
	const { t } = useTranslation();

	return useMemo(() => ({
		id: "exceptions",
		Header: t("clock-exceptions"),
		filter: "select",
		canFilter: true,
		Filter: (
			<Select mode="multiple">
				{options.map(([value, label]) => (
					<Select.Option key={value} value={value}>{t(label)}</Select.Option>
				))}
			</Select>
		),
	}), [t]);
};
